<template>
  <v-btn icon @click="toggleMainMenu">
    <hb-icon>menu</hb-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'MainMenuButton',
  methods: {
    toggleMainMenu() {
      this.$store.commit('toggleMainMenuState');
    },
  },
};
</script>

<style scoped></style>
